import { render, staticRenderFns } from "./PriceVariationList.vue?vue&type=template&id=73ba8e2e"
import script from "./PriceVariationList.vue?vue&type=script&lang=js"
export * from "./PriceVariationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports